export default "/assets/site/images/favicon-16x16.png?42e17825d3e0067692089c9f4342c59b";